<template>
  <div class="container mb013">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">ご登録口座へのお振込み</HeadingOne>

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="1" type="mb"></MainWizard>
    </WizardGroup>

    <section class="_mb-sm-40 _mb-md-60">
      <p class="_mb-0">
        内容をご確認のうえ、よろしければ「お申し込み」を押してください。
      </p>
      <p class="_mb-0">＜ご注意＞</p>
      <p>
        <BtnText
          v-scroll-to="{ el: '#section_01', offset: -150 }"
          :to="{ path: '#' }"
          class="-underline"
          >下記メンテナンス時間</BtnText
        >は、お申し込みができません。
      </p>
      <p class="txt01">
        また、ご利用されている金融機関が営業時間外の場合にはお振込みができませんので、お手続き完了後にメールおよび会員さま専用サイトのメッセージにてお知らせいたします。その際、お申し込みは予約扱いにはなりません。
      </p>
      <p class="txt01">
        お急ぎの場合は、その他のお借り入れ方法をご利用ください。
      </p>
      <small class="txt01"
        >※ご利用されている金融機関の営業時間は会員さまにてご確認ください。</small
      >

      <TableBox class="_mb-sm-40 _mb-md-60 _mt-30">
        <TableBody>
          <TableRow>
            <TableHeader class="-requires"> ご登録の口座 </TableHeader>
            <TableData class="-pctextright">
              金融機関名：{{ userData.bank_name }}<br />
              支店名：{{ userData.branch_name }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> お借り入れ金額 </TableHeader>
            <TableData class="-pctextright">
              {{ numberToCurrency(userData.amount * 10000) }}
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <div id="section_01" name="section_01">
        <small
          >※年末年始などの特定日や、メンテナンス時間帯はご利用いただけません。他のお借り入れ方法にてご利用ください。</small
        >
        <HeadingFour class="_mt-10 _mb-10"
          >ご利用いただけない時間帯および特定日</HeadingFour
        >
        <p>
          毎日深夜2:00～4:00<br />
          毎週日曜日19:00～翌月曜日8:00<br />
          年始1月1日～3日、ゴールデンウィーク5月3日～5日
        </p>

        <HeadingFour class="_mt-20 _mb-10">その他のお借り入れ方法</HeadingFour>
        <BtnText router-name="mb012" class="-next -ib _mb-md-10 _mb-sm-15"
          >au PAY 残高にチャージ</BtnText
        ><br />
        <BtnText router-name="sv025" target="_blank" class="-next -ib"
          >セブン銀行スマホＡＴＭ</BtnText
        >
      </div>
    </section>

    <form novalidate @submit.prevent="submitDepositIntoAccount">
      <BtngroupSingle class="_mb-sm-40">
        <BtnMain class="-main" @click.prevent="submitDepositIntoAccount">
          お申し込み
        </BtnMain>
      </BtngroupSingle>
    </form>

    <BtngroupSingle class="-margin-lg">
      <BtnBack class="-back -md" router-name="mb011"> 修正する </BtnBack>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  submitDepositIntoAccountLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { numberToCurrency } from "@/utils/Filter";
import HeadingOne from "@/components/heading/HeadingOne";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtnText from "@/components/button/BtnText";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import HeadingFour from "@/components/heading/HeadingFour";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb013",
  components: {
    HeadingFour,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    BtnText,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    MainWizard,
    WizardGroup,
    ErrorsAlert,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご登録口座へのお振込み｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,指定口座,振込",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご登録口座へのお振込み",
          active: true,
        },
      ],
      errors: null,
      isDisabled: false,
      userData: {
        bank_name: "",
        branch_name: "",
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          this.goToErrorPage(error);
        });
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
  methods: {
    submitDepositIntoAccount() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            submitDepositIntoAccountLambdaInvoke()
              .then((res) => {
                if (res.errors) {
                  this.errors = res.errors;
                  this.scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "tem007" });
                }
              })
              .catch((error) => {
                this.goToErrorPage(error);
              });
          })
          .catch((error) => {
            this.goToErrorPage(error);
          });
      } catch (e) {
        this.goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-text {
  font-size: 16px;
  padding: 0;
}
.mb013 {
  .txt01 {
    color: $danger;
  }
  .-underline {
    text-decoration: underline;
  }
}
</style>
